<div>
  <span class="fi" class="{{ _flagIcon }}"></span>
  <mat-chip class="language-label" *ngIf="_hasLabel">
    {{ _languageName }}
  </mat-chip>
  <!-- <div *ngIf="_hasLabel">{{_ddcLng}}</div> -->
</div>
